export function PageLoader() {
  return (
    <div role="status" className="flex h-40 items-center justify-center gap-3 text-body text-muted-foreground">
      <div aria-hidden="true" className="h-5 w-5 animate-spin rounded-full border-2 border-primary border-t-transparent" />
      Loading…
    </div>
  );
}
